<template>
    <div>
        <PagesAboutUs tab="3" sub="22" lang="en"></PagesAboutUs>
    </div>
</template>

<script setup lang="ts">
import { PagesAboutUs } from '#components';
import langObj from "@/utils/lang";
var lng: any = langObj['en']
useSeoMeta({
    title: lng['力士达集团'],
    description: '力士达集团',
    keywords: '力士达, lsd',
});
</script>